'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define(['accessibilityFocusHelper'], function (accessibilityFocusHelper) {
  var AccessibleModalHelper = function () {
    function AccessibleModalHelper(containerElement, closeHandler, startElement) {
      _classCallCheck(this, AccessibleModalHelper);

      this.containerElement = containerElement;
      this.closeHandler = closeHandler;

      if (containerElement) {
        this.load(startElement);
      }
    }

    _createClass(AccessibleModalHelper, [{
      key: 'load',
      value: function load(startElement) {
        this.setUpFocusVariables();

        if (startElement) {
          accessibilityFocusHelper.focus(startElement);
        } else {
          this.firstFocusableEl && this.firstFocusableEl.focus();
        }

        this.addKeyBoardHandler();
      }
    }, {
      key: 'reload',
      value: function reload(newContainer, newStartElement) {
        if (newContainer) {
          this.containerElement = newContainer;
          this.load(newStartElement);
        }
      }
    }, {
      key: 'close',
      value: function close() {
        this.removeKeyBoardHandler();
        this.focusedElBeforeOpen.focus();
      }

      /**
       * Set up the focus variables for tab handling
       */

    }, {
      key: 'setUpFocusVariables',
      value: function setUpFocusVariables() {
        this.focusedElBeforeOpen = this.focusedElBeforeOpen || document.activeElement;

        var focusableEls = this.containerElement.querySelectorAll('a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        this.focusableEls = Array.prototype.slice.call(focusableEls).filter(function (el) {
          return el.offsetParent;
        }).filter(function (el) {
          return el.getAttribute('tabindex') !== '-1';
        }); // Remove hidden elements
        this.firstFocusableEl = this.focusableEls[0];
        this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
      }
    }, {
      key: 'keyboardHandler',
      value: function keyboardHandler(SELF) {
        var _this = this;

        return function (event) {
          var handleBackwardTab = function handleBackwardTab() {
            if (document.activeElement === _this.firstFocusableEl) {
              event.preventDefault();
              SELF.lastFocusableEl.focus();
            }
          };
          var handleForwardTab = function handleForwardTab() {
            if (document.activeElement === SELF.lastFocusableEl) {
              event.preventDefault();
              SELF.firstFocusableEl.focus();
            }
          };
          switch (event.key) {
            case 'Tab':
              {
                if (event.shiftKey) {
                  handleBackwardTab();
                } else {
                  handleForwardTab();
                }
                break;
              }
            case 'Escape':
              {
                SELF.closeHandler();
                break;
              }
            default:
              break;
          }
        };
      }
    }, {
      key: 'addKeyBoardHandler',
      value: function addKeyBoardHandler() {
        document.addEventListener('keydown', this.keyboardHandler(this));
      }
    }, {
      key: 'removeKeyBoardHandler',
      value: function removeKeyBoardHandler() {
        document.removeEventListener('keydown', this.keyboardHandler(this));
      }
    }]);

    return AccessibleModalHelper;
  }();

  return AccessibleModalHelper;
});
//# sourceMappingURL=accessibleModalHelper.js.map
